<template>
  <div :class="containerClass" @click="selectChip" :style="chipStyle">
    <img v-if="imgSrc" :src="imgSrc" :class="imgClass" />
    <lego-icon v-if="icon" :class="iconClass" icon-type="df">{{ icon }}</lego-icon>
    <div
      :class="slotClass"
      @click="onIconClick"
      v-lego-tooltip="{
        arg: 'ellipsis',
        value: tooltip,
        moreAction: 'tooltipUnique',
        isShowHTML: true
      }"
    >
      <!--
            $ver: v0.1.0
            칩 내부에 위치하는 문자열 입니다.
            #A string located inside the chip.
         --><slot
      ></slot>
    </div>
    <lego-icon
      v-if="removable"
      :class="closeClass"
      icon="delete"
      icon-type="df"
      @click.stop="onClick"
      @mouseover="closeHover = true"
      @mouseleave="
        closeHover = false;
        closePressed = false;
      "
      @mousedown="closePressed = true"
      @mouseup="closePressed = false"
    />
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    statusColor: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['success', 'error', 'default', 'processing', 'warning'].indexOf(value) !== -1;
      }
    },
    compact: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    size: {
      validator: function (value) {
        return ['medium', 'small', 'xsmall'].indexOf(value) !== -1;
      }
    },
    xsmall: { type: Boolean, default: false },
    maxWidth: {
      type: [Number, String],
      default: 460
    },
    itemData: { type: Object, default: () => {} }
  },
  computed: {
    tooltip() {
      if (this.$util.isNotEmpty(this.itemData)) {
        return (
          (this.itemData.type === 'USER'
            ? this.$util.escapeHTML(this.itemData.name)
            : this.$util.escapeHTML(this.itemData.addressBookName)) +
          '/' +
          this.$util.escapeHTML(this.itemData.info)
        );
      }
      const getChildrenName = (childrens) => {
        if (Array.isArray(childrens)) {
          return getChildrenName(childrens[0].children);
        }
        return childrens;
      };
      return getChildrenName(this.$slots.default());
    },
    containerClass() {
      return this.disabled
        ? [
            'lego-chip__container',
            'lego-chip__container-' + this.cSize,
            !this.imgSrc && 'lego-chip__container-non-image',
            'lego-chip__container-disabled'
          ]
        : [
            'lego-chip__container',
            'lego-chip__container-' + this.cSize,
            !this.imgSrc && 'lego-chip__container-non-image',
            'lego-chip__container-' + this.colorType,
            this.statusColor &&
              'lego-chip__container-status lego-chip__container-' + this.statusColor,
            this.compact && 'lego-chip__container-status lego-chip__container-compact',
            this.isSelect && 'lego-chip__container-filter-is-selected',
            this.isSelect &&
              this.colorType === 'normal' &&
              this.selected &&
              'lego-chip__container-filter-selected'
          ];
    },
    slotClass() {
      return [
        'lego-chip__slot',
        this.cSize === 'small' && 'lego-chip__slot-small',
        this.disabled && 'lego-chip__slot-disabled'
      ];
    },
    chipStyle() {
      return {
        maxWidth: !isNaN(this.maxWidth) ? this.maxWidth + 'px' : this.maxWidth
      };
    },
    cSize() {
      if (this.size) {
        console.warn(
          '[LEGO-CHIP] props:size was deprecated from v0.1.2. use medium or small flag props. and will be deleted on Dec.2020 (v1.3.0)'
        );
        return this.size;
      }
      if (this.medium || this.md) return 'medium';
      if (this.small || this.sm) return 'small';
      if (this.xsmall) return 'xsmall';
      return this.default.size;
    },
    closeClass() {
      return this.disabled
        ? [
            'lego-chip__icon',
            'lego-chip__close',
            'lego-chip__close-' + this.cSize,
            'lego-chip__close-disabled'
          ]
        : [
            'lego-chip__icon',
            'lego-chip__close',
            'lego-chip__close-' + this.cSize,
            this.closeHover && 'lego-chip__close-hover',
            this.closePressed && 'lego-chip__close-active'
          ];
    }
  },

  methods: {
    onClick() {
      this.$emit('delete');
    },
    selectChip() {
      if (this.isSelect) {
        this.selected = !this.selected;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-chip__container {
  .lego-chip__slot {
    margin: 0;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &.lego-chip__container-disabled {
    pointer-events: none;
    opacity: 0.6;
    color: $color--ui07;
    border: solid 1px $color--primary-tint02;
    background-color: $color--primary-tint01;
  }

  &:not(.lego-chip__container-compact).lego-chip__container-medium {
    min-width: 60px;
    padding: 0 16px;
  }
  &:not(.lego-chip__container-compact).lego-chip__container-small {
    min-width: 48px;
    padding: 0 8px;
  }
  &:not(.lego-chip__container-compact).lego-chip__container-xsmall {
    min-width: 40px;
    padding: 0 8px;
    border-radius: 20px;
    height: $lego-chip__height--xsmall;
    line-height: $lego-chip__height--xsmall;
    font-size: $lego-chip__font-size--small;
  }
  &.lego-chip__container-filter-is-selected {
    cursor: pointer;

    &:not(.lego-chip__container-filter-selected):hover {
      background-color: $color--primary-tint02;
    }
    &:not(.lego-chip__container-filter-selected):active {
      background-color: $color--primary-tint03;
    }
  }

  &.lego-chip__container-filter-selected {
    background-color: $color--primary;
    color: $color--ui-white;
    border-color: $color--primary;
    :deep .lego-chip__close {
      color: $color--ui-white;
    }
  }
  background-color: $lego-chip__background-color;
  border: 1px solid $color--primary-tint02;

  &-normal {
    background-color: $lego-chip__background-color;
  }

  &-thick {
    background-color: $color--primary;
    color: $color--ui-white;
    border: $color--primary;
  }

  &-light {
    background-color: map_get($lego-chip__background-color--input, light);
    color: map_get($lego-chip__font-color--input, light);
  }

  &-status {
    border: 0;
  }
  &-success {
    background-color: $color--status-success;
    &:before {
      background-color: $color--status-success;
    }
  }
  &-error {
    background-color: $color--status-error;
    &:before {
      background-color: $color--status-error;
    }
  }
  &-processing {
    background-color: $color--status-processing;
    &:before {
      background-color: $color--status-processing;
    }
  }
  &-default {
    background-color: $color--status-default;
    &:before {
      background-color: $color--status-default;
    }
  }
  &-warning {
    background-color: $color--status-warning;
    &:before {
      background-color: $color--status-warning;
    }
  }

  &-compact {
    @include font(12px);
    height: inherit;
    background-color: transparent;

    &:before {
      content: '';
      width: 10px;
      height: 10px;
      flex: 0 0 10px;
      border-radius: 50%;
    }
    .lego-chip__slot {
      color: $color--ui-03;
      margin: 0 0 0 6px;
    }
  }
}

:deep .lego-chip__close {
  color: $lego-chip__close__icon-color;
  &-medium {
    margin: $lego-chip__close__icon-margin;
    font-size: $lego-chip__close__icon-size--medium;
  }

  &-disabled {
    color: $lego-chip__close__icon-color--disabled;
    cursor: default;
    pointer-events: none;
  }

  &-hover {
    color: $lego-chip__close__icon-color--hover;
    background: none;
  }
}
.lego-chip-wrapper__item {
  margin-bottom: 12px;
}
</style>
